
import { Component, Vue, Prop } from "vue-property-decorator";
import { NavigationStore } from "@/store/navigation";
@Component({})
export default class AppCartSteps extends Vue {
  NavigationStore: any = NavigationStore;
  @Prop({ required: true })
  step!: number;
}
